import type { FunctionComponent } from 'react';
import { Button } from '@fff-web/fff-ui-shared';
import ButtonAction from '../../interfaces/buttonAction';
import breakpoints from '../../utils/breakpoints';
import useCurrentWidth from '../commons/use-current-width/useCurrentWidth';
import * as styles from './NavigationFooter.module.css';

type OwnProps = {
  backButton: ButtonAction;
  nextButton: ButtonAction;
  isQuestionPage?: boolean;
};

const NavigationFooter: FunctionComponent<OwnProps> = ({
  backButton,
  nextButton,
  isQuestionPage,
}) => {
  const questionMargins = isQuestionPage ? styles.questionMargins : '';
  const currentWidth = useCurrentWidth();
  const width = currentWidth < breakpoints.small ? 351 : 273;

  return (
    <div className={`${styles.navigationFooterContainer} ${questionMargins}`}>
      <div>
        <Button
          variation={backButton.type}
          width={width}
          onClick={backButton.onClick}
          disabled={backButton.disabled}
        >
          {backButton.label}
        </Button>
      </div>
      <div className={styles.nextButton}>
        <Button
          variation={nextButton.type}
          width={width}
          onClick={nextButton.onClick}
          disabled={nextButton.disabled}
        >
          {nextButton.label}
        </Button>
      </div>
    </div>
  );
};

export default NavigationFooter;
